// @flow
import {useCallback} from 'react';
import {useState} from 'react';
import {useIsMinimalPlan} from '../modules/store/utils';

type ContextProps = {
  openRestriction: boolean,
  handleCloseRestriction: () => void,
  handleOpenRestriction: () => void,
};

export function useMinimalTierContext(): ContextProps {
  const isMinimalPlan = useIsMinimalPlan();
  const [openRestriction, setOpenRestriction] = useState<boolean>(
    isMinimalPlan
  );

  const handleCloseRestriction = useCallback(() => {
    if (isMinimalPlan) setOpenRestriction(false);
  }, [isMinimalPlan]);

  const handleOpenRestriction = useCallback(() => {
    if (isMinimalPlan) setOpenRestriction(true);
  }, [isMinimalPlan]);

  return {
    openRestriction,
    handleCloseRestriction,
    handleOpenRestriction,
  };
}
